import { ExportConfiguration } from '../export/exportConfiguration';
import { ExportType } from '../export/export';
import { translate } from '../translation/Translator';
import { TranslationKey } from '../translation/TranslationKey';
import { TranslationLanguage } from '../translation/translation';

export const ProductMasterDataExportConfigurationField = {
  productName: 'productName',
  productNumber: 'productNumber',

  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',

  globalTradeItemNumber: 'globalTradeItemNumber',

  purchasePrice: 'purchasePrice',
  sellingPrice: 'sellingPrice',

  unitOfMeasure: 'unitOfMeasure',
} as const;

export type ProductMasterDataExportConfigurationField =
  (typeof ProductMasterDataExportConfigurationField)[keyof typeof ProductMasterDataExportConfigurationField];

export class ProductMasterDataExportConfiguration extends ExportConfiguration<ProductMasterDataExportConfigurationField> {
  static default(companyId: string, language?: TranslationLanguage) {
    return new ProductMasterDataExportConfiguration({
      companyId,
      name: '',
      type: ExportType.xlsx,
      filename: 'ventory_product_reference_data_${TIMESTAMP}',
      mapping: new Map([
        [
          ProductMasterDataExportConfigurationField.productName,
          { value: translate({ key: TranslationKey.productName, language }), index: 1 },
        ],
        [
          ProductMasterDataExportConfigurationField.productNumber,
          { value: translate({ key: TranslationKey.productNumber, language }), index: 3 },
        ],
      ]),
    });
  }
}
